export default __webpack_public_path__ + "static/media/CardTap.aa8cd982.png";